import { useEventsContext } from "../context/EventsContext";

export const useEvents = () => {
  return useEventsContext();

};
